import { gql, type TypedDocumentNode } from "@apollo/client";
import { CRM_NOTE_FIELDS_FRAGMENT } from "@/fragments";
import type { CRMNote } from "@/types";
import type { FacilityGovernancePerson, GovernanceTitle } from "./types";

export interface FacilityGovernanceRoleNode {
  id: string;
  status: string;
  title: GovernanceTitle;
  person: FacilityGovernancePerson;
  notes: CRMNote[];
}

export interface FacilityGovernanceRolesQueryData {
  facility: {
    id: string;
    governanceRoles: FacilityGovernanceRoleNode[];
  };
}

export interface FacilityGovernanceRolesQueryVariables {
  facilityId: string;
}

export const FACILITY_GOVERNANCE_ROLES_QUERY: TypedDocumentNode<
  FacilityGovernanceRolesQueryData,
  FacilityGovernanceRolesQueryVariables
> = gql`
  query FacilityGovernanceRoles($facilityId: ID!) {
    facility(id: $facilityId) {
      id
      governanceRoles {
        id
        status
        title {
          id
          title
        }
        person {
          id
          displayName
          pgaId
          profilePhoto
          latestProgram {
            programType {
              id
              name
            }
          }
        }
        notes {
          ...CRMNoteFields
        }
      }
    }
  }
  ${CRM_NOTE_FIELDS_FRAGMENT}
`;

export interface FacilityGovernanceTitlesQueryData {
  facilityGovernanceTitles: GovernanceTitle[];
}

export const FACILITY_GOVERNANCE_TITLES_QUERY: TypedDocumentNode<FacilityGovernanceTitlesQueryData> = gql`
  query FacilityGovernanceTitles {
    facilityGovernanceTitles {
      id
      title
    }
  }
`;
